import { useEffect, useState } from 'react';

/**
 * حد `lg` في Tailwind هو نفسه الحد الذي تبدّل عنده القشرة بين Sidebar وBottomTabBar
 * (§6.10) — فسطح الالتقاط يبدّل عنده أيضًا: CapturePalette فوقه وCaptureSheet تحته.
 */
const DESKTOP_QUERY = '(min-width: 1024px)';

/**
 * ارتفاع ما يغطيه لوح المفاتيح من أسفل الشاشة (px). العناصر `fixed` تبقى ملتصقة
 * بالـ layout viewport في Safari/iOS فيختفي حقل الالتقاط تحت اللوح — وهذا مرفوض في
 * أهم سطح في النظام. الحساب من `visualViewport` لا من حِيَل الـ meta كي يبقى الأثر
 * محصورًا في الورقة ولا يمس تخطيط الشاشات الأخرى.
 */
export function useKeyboardInset(active: boolean): number {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!active || viewport === null || viewport === undefined) {
      setInset(0);
      return;
    }
    const update = (): void => {
      const covered = window.innerHeight - (viewport.height + viewport.offsetTop);
      setInset(covered > 24 ? Math.round(covered) : 0);
    };
    update();
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);
    return () => {
      viewport.removeEventListener('resize', update);
      viewport.removeEventListener('scroll', update);
    };
  }, [active]);

  return inset;
}

export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState<boolean>(() => window.matchMedia(DESKTOP_QUERY).matches);

  useEffect(() => {
    const media = window.matchMedia(DESKTOP_QUERY);
    const onChange = (): void => setIsDesktop(media.matches);
    setIsDesktop(media.matches);
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, []);

  return isDesktop;
}
